(() => {
  if (window.__UPCART_CUSTOM_ENHANCEMENTS__) return;
  window.__UPCART_CUSTOM_ENHANCEMENTS__ = true;

  /* ---------------------------
    1) Delivery + Discounts row
  ----------------------------*/

  const htmlToInsert = {
    desktop: `
      <div class="delivery-time">
        <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.4 10.5625C6.4 11.9082 5.325 13 4 13C2.65 13 1.6 11.9082 1.6 10.5625C0.7 10.5625 0 9.85156 0 8.9375V1.625C0 0.736328 0.7 0 1.6 0H8.8C9.675 0 10.4 0.736328 10.4 1.625V2.4375H11.45C11.825 2.4375 12.175 2.58984 12.45 2.86914L14.775 5.23047C15.05 5.50977 15.2 5.86523 15.2 6.24609V9.34375H15.4C15.725 9.34375 16 9.62305 16 9.95312C16 10.3086 15.725 10.5625 15.4 10.5625H14.4C14.4 11.9082 13.325 13 12 13C10.65 13 9.6 11.9082 9.6 10.5625H6.4ZM8.8 1.21875H1.6C1.375 1.21875 1.2 1.42188 1.2 1.625V8.9375C1.2 9.16602 1.375 9.34375 1.6 9.34375H1.9C2.325 8.63281 3.1 8.125 4 8.125C4.875 8.125 5.65 8.63281 6.075 9.34375H8.8C9 9.34375 9.2 9.16602 9.2 8.9375V1.625C9.2 1.42188 9 1.21875 8.8 1.21875ZM11.6 3.73242C11.55 3.68164 11.5 3.65625 11.45 3.65625H10.4V6.09375H13.95C13.925 6.09375 13.925 6.09375 13.925 6.09375L11.6 3.73242ZM4 9.34375C3.325 9.34375 2.8 9.90234 2.8 10.5625C2.8 11.248 3.325 11.7812 4 11.7812C4.65 11.7812 5.2 11.248 5.2 10.5625C5.2 9.90234 4.65 9.34375 4 9.34375ZM12 11.7812C12.65 11.7812 13.2 11.248 13.2 10.5625C13.2 9.90234 12.65 9.34375 12 9.34375C11.325 9.34375 10.8 9.90234 10.8 10.5625C10.8 11.248 11.325 11.7812 12 11.7812Z" fill="#282828"/>
</svg>
        <span>Expected Delivery for the US: <b>2-5 Business Days</b></span>
      </div>
    `
  };

  const discountsRowHTML = `
    <div class="cartDiscountsTitle alignLeft" data-cart-discounts-row style="margin-top: 6px;">
      Discount
      <span class="cartDiscountsValue alignRight">
        <span class="money notranslate" data-cart-discounts-money>$0.00</span>
      </span>
    </div>
  `;

  const cartSelectors = {
    badge: '.upcart-trust-badge',
    summary: '.cartSummarySection',
    subtotalRow: '.cartSubtotalTitle',

    item: '.upcart-product-item',
    price: '.upcart-item-price .money',              // LINE TOTAL
    compare: '.upcart-item-compare-price .money',    // LINE TOTAL

    plus: '.upcart-product-quantity-plus',
    minus: '.upcart-product-quantity-minus',
    qtyInput: '.upcart-product-quantity-input',
    trash: '.styles_TrashButton__deleteButton__',
  };

  let insertedDelivery = false;
  let lastKnownCents = null;
  let lastSummaryEl = null;
  let cartDebounceTimer = null;

  function moneyToCents(text) {
    if (!text) return 0;
    const cleaned = String(text).replace(/\s/g, '').replace(/[^0-9.,-]/g, '');
    if (!cleaned) return 0;

    const lastDot = cleaned.lastIndexOf('.');
    const lastComma = cleaned.lastIndexOf(',');

    let normalized = cleaned;
    if (lastDot !== -1 && lastComma !== -1) {
      const decimalSep = lastDot > lastComma ? '.' : ',';
      const thousandSep = decimalSep === '.' ? ',' : '.';
      normalized = normalized.split(thousandSep).join('');
      normalized = normalized.replace(decimalSep, '.');
    } else if (lastComma !== -1 && lastDot === -1) {
      normalized = normalized.replace(',', '.');
    }

    const n = Number(normalized);
    if (Number.isNaN(n)) return 0;
    return Math.round(n * 100);
  }

  function formatDollarsFromCents(cents) {
    const n = Math.max(0, Math.round(cents || 0)) / 100;
    return `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  function ensureDeliveryOnce() {
    if (insertedDelivery) return;
    const logo = document.querySelector(cartSelectors.badge);
    if (!logo) return;
    logo.insertAdjacentHTML('afterend', htmlToInsert.desktop);
    insertedDelivery = true;
  }

  function ensureDiscountRow() {
    const summary = document.querySelector(cartSelectors.summary);
    if (!summary) return false;

    if (lastSummaryEl !== summary) lastSummaryEl = summary;

    if (summary.querySelector('[data-cart-discounts-row]')) return true;

    const subtotalRow = summary.querySelector(cartSelectors.subtotalRow);
    if (!subtotalRow) return false;

    subtotalRow.insertAdjacentHTML('beforebegin', discountsRowHTML);
    return true;
  }

  function setDiscountValue(cents) {
    const row = document.querySelector('[data-cart-discounts-row]');
    const moneyEl = row?.querySelector('[data-cart-discounts-money]');
    if (!row || !moneyEl) return;

    const v = Math.max(0, Math.round(cents || 0));
    row.style.display = v > 0 ? '' : 'none';
    if (v > 0) moneyEl.textContent = formatDollarsFromCents(v);
  }

  function calcDiscountsFromDOM() {
    const items = Array.from(document.querySelectorAll(cartSelectors.item));
    if (!items.length) return { ready: true, cents: 0 };

    let sum = 0;

    for (const item of items) {
      const priceEl = item.querySelector(cartSelectors.price);
      if (!priceEl) return { ready: false, cents: 0 };

      const priceCents = moneyToCents(priceEl.textContent);
      if (!priceCents) return { ready: false, cents: 0 };

      const compareEl = item.querySelector(cartSelectors.compare);
      const compareCents = moneyToCents(compareEl?.textContent);

      // LINE TOTALS already reflect qty
      if (compareCents && compareCents > priceCents) {
        sum += (compareCents - priceCents);
      }
    }

    return { ready: true, cents: sum };
  }

  function updateDiscounts() {
    ensureDeliveryOnce();
    if (!ensureDiscountRow()) return;

    // avoid flash: keep last while re-rendering
    if (lastKnownCents != null) setDiscountValue(lastKnownCents);

    const { ready, cents } = calcDiscountsFromDOM();
    if (!ready) return;

    lastKnownCents = Math.max(0, cents);
    setDiscountValue(lastKnownCents);
  }

  function scheduleDiscountsUpdate(delay = 120) {
    clearTimeout(cartDebounceTimer);
    cartDebounceTimer = setTimeout(updateDiscounts, delay);
  }

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (
      t.closest(cartSelectors.plus) ||
      t.closest(cartSelectors.minus) ||
      t.closest(cartSelectors.trash)
    ) {
      scheduleDiscountsUpdate(180);
      return;
    }
    scheduleDiscountsUpdate(250);
  }, { passive: true });

  document.addEventListener('input', (e) => {
    if (e.target && e.target.matches(cartSelectors.qtyInput)) {
      scheduleDiscountsUpdate(180);
    }
  }, { passive: true });

  // light polling only to insert when drawer is opened / route change
  setInterval(() => {
    if (document.querySelector(cartSelectors.summary)) scheduleDiscountsUpdate(0);
  }, 500);

  scheduleDiscountsUpdate(0);

  /* ---------------------------
    2) Upsell carousel (Splide)
  ----------------------------*/

  if (window.__UPCART_UPSELL_CUSTOM_FULL_V2__) return;
  window.__UPCART_UPSELL_CUSTOM_FULL_V2__ = true;

  const MODULE_SEL = '#up-upsell-carousel';
  const WRAPPER_SEL = ':scope > span > .styles_PreviewCarousel__verticalWrapper__';
  const HIDDEN_KEY = '__upcart_hidden_upsells__';

  let moduleObserver = null;
  let scheduled = false;

  function getHidden() {
    try { return JSON.parse(sessionStorage.getItem(HIDDEN_KEY) || '[]'); }
    catch { return []; }
  }

  function setHidden(arr) {
    try { sessionStorage.setItem(HIDDEN_KEY, JSON.stringify(arr.slice(0, 50))); } catch { }
  }

  function getIdForCard(cardEl) {
    const a = cardEl.querySelector('a[href*="/products/"]');
    const href = a?.getAttribute('href') || '';
    if (!href) return null;
    return href.split('?')[0].split('#')[0];
  }

  function injectStylesOnce() {
    if (document.querySelector('#upcart-upsell-css-slider-styles')) return;
    const style = document.createElement('style');
    style.id = 'upcart-upsell-css-slider-styles';
    style.textContent = `
      #up-upsell-carousel { position: relative; }

/* Track */
#up-upsell-carousel [data-upsell-track]{
  display: flex;
  gap: 12px; /* requested */
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  padding: 0 15px 8px 0;
  touch-action: pan-x;
  margin-right: -15px;
}
#up-upsell-carousel [data-upsell-track]::-webkit-scrollbar{ height: 0; }
#up-upsell-carousel [data-upsell-track]{ scrollbar-width: none; }

/* Slides (desktop shows peek of next card) */
#up-upsell-carousel [data-upsell-slide]{
  flex: 0 0 78%;
  scroll-snap-align: start;
}
@media (min-width: 900px){
  #up-upsell-carousel [data-upsell-slide]{
    flex-basis: 72%;
  }
}

/* ✅ MOBILE: full width (no peek) so it doesn't look "cut" */
@media (max-width: 768px){
  #up-upsell-carousel [data-upsell-track]{
    padding-right: 0;
    margin-right: 0;
  }
  #up-upsell-carousel [data-upsell-slide]{
    flex-basis: 100%;
  }

  /* optional: make cards feel less tall on mobile */
  #up-upsell-carousel .upcart-upsell-item-image-wrapper img{
    max-height: 84px;
    object-fit: cover;
  }
  #up-upsell-carousel .upcart-upsell-item-card{
    padding: 14px !important;
  }
  #up-upsell-carousel .upcart-upsells-button{
    padding: 10px 14px !important;
    min-height: 40px !important;
  }
}

/* Drag cursor */
#up-upsell-carousel [data-upsell-track]{ cursor: grab; }
#up-upsell-carousel [data-upsell-track].is-dragging{ cursor: grabbing; user-select:none; }

/* Arrows */
#up-upsell-carousel [data-upsell-arrows]{
  position: absolute;
  right: 14px;
  top: 18px;
  display: flex;
  gap: 10px;
  z-index: 9999;
}
#up-upsell-carousel [data-upsell-arrow]{
  width: 30px;
  height: 30px;
  border-radius: 999px;
  background: #eaf0ef;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
}
#up-upsell-carousel [data-upsell-arrow] svg{
  width: 16px;
  height: 16px;
  fill: #111;
}
#up-upsell-carousel [data-upsell-arrow][disabled]{
  opacity: .35;
  pointer-events: none;
}
    `;
    document.head.appendChild(style);
  }

  function ensureArrows(moduleEl) {
    if (moduleEl.querySelector('[data-upsell-arrows]')) return;

    const arrows = document.createElement('div');
    arrows.setAttribute('data-upsell-arrows', '');

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.setAttribute('data-upsell-arrow', 'prev');
    prev.setAttribute('aria-label', 'Previous');
    prev.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.2227 9.86989C16.2227 10.2527 15.9219 10.5535 15.5664 10.5535H6.26953L9.90625 13.9988C10.1797 14.2449 10.1797 14.6824 9.93359 14.9285C9.6875 15.2019 9.27734 15.2019 9.00391 14.9558L4.19141 10.3621C4.05469 10.2254 4 10.0613 4 9.86989C4 9.70582 4.05469 9.54176 4.19141 9.40504L9.00391 4.81129C9.27734 4.5652 9.6875 4.5652 9.93359 4.83864C10.1797 5.08473 10.1797 5.52223 9.90625 5.76832L6.26953 9.21364H15.5664C15.9492 9.21364 16.2227 9.51442 16.2227 9.86989Z" fill="#2C2523"/></svg>`;

    const next = document.createElement('button');
    next.type = 'button';
    next.setAttribute('data-upsell-arrow', 'next');
    next.setAttribute('aria-label', 'Next');
    next.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.77734 10.1301C3.77734 9.74733 4.07812 9.44655 4.43359 9.44655H13.7305L10.0938 6.00123C9.82031 5.75514 9.82031 5.31764 10.0664 5.07155C10.3125 4.79811 10.7227 4.79811 10.9961 5.0442L15.8086 9.63795C15.9453 9.77467 16 9.93873 16 10.1301C16 10.2942 15.9453 10.4583 15.8086 10.595L10.9961 15.1887C10.7227 15.4348 10.3125 15.4348 10.0664 15.1614C9.82031 14.9153 9.82031 14.4778 10.0938 14.2317L13.7305 10.7864H4.43359C4.05078 10.7864 3.77734 10.4856 3.77734 10.1301Z" fill="#2C2523"/></svg>`;

    arrows.appendChild(prev);
    arrows.appendChild(next);

    const title = moduleEl.querySelector('.upcart-upsells-title') || moduleEl.querySelector('h2');
    if (title) title.appendChild(arrows);
    const title_text = title?.querySelector("p");
    if (title_text) {
      //title_text.textContent = "Enhance your experience";
    }
    else moduleEl.appendChild(arrows);
  }

  // ✅ FIX: reconcile ALWAYS (even if track exists)
  function reconcileSlider(moduleEl) {
    if (!moduleEl) return false;

    let track = moduleEl.querySelector('[data-upsell-track]');
    if (!track) {
      track = document.createElement('div');
      track.setAttribute('data-upsell-track', '');
      const title = moduleEl.querySelector('.upcart-upsells-title') || moduleEl.querySelector('h2');
      if (title) title.insertAdjacentElement('afterend', track);
      else moduleEl.prepend(track);
    }

    // Find all upsell spans that UpCart renders (but exclude ones already inside track)
    const wrappers = Array.from(moduleEl.querySelectorAll(WRAPPER_SEL));
    if (!wrappers.length) return true;

    const freshSpans = wrappers
      .map(w => w.closest('span'))
      .filter(Boolean)
      .filter(span => !span.closest('[data-upsell-track]')); // only those OUTSIDE the track

    // Move new spans into track as slides
    freshSpans.forEach(span => {
      const slide = document.createElement('div');
      slide.setAttribute('data-upsell-slide', '');
      slide.appendChild(span);
      track.appendChild(slide);
    });

    // If track has no slides (edge cases), but wrappers exist, rebuild from scratch
    const hasSlides = track.querySelector('[data-upsell-slide]');
    if (!hasSlides && wrappers.length) {
      // clear
      track.innerHTML = '';
      wrappers.forEach(w => {
        const span = w.closest('span');
        if (!span) return;
        const slide = document.createElement('div');
        slide.setAttribute('data-upsell-slide', '');
        slide.appendChild(span);
        track.appendChild(slide);
      });
    }

    return true;
  }

  function getScrollAmount(track) {
    const slide = track.querySelector('[data-upsell-slide]');
    if (!slide) return Math.max(240, track.clientWidth * 0.8);
    return slide.getBoundingClientRect().width + 12;
  }

  function updateArrowState(track, prevBtn, nextBtn) {
    const max = track.scrollWidth - track.clientWidth - 2;
    const x = track.scrollLeft;
    prevBtn.disabled = x <= 1;
    nextBtn.disabled = x >= max;
  }

  function enableDragScroll(track) {
    if (track.dataset.dragBound === '1') return;
    track.dataset.dragBound = '1';

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    const onDown = (e) => {
      isDown = true;
      track.classList.add('is-dragging');
      startX = (e.pageX ?? e.touches?.[0]?.pageX ?? 0);
      scrollLeft = track.scrollLeft;
    };

    const onMove = (e) => {
      if (!isDown) return;
      const x = (e.pageX ?? e.touches?.[0]?.pageX ?? 0);
      track.scrollLeft = scrollLeft + (startX - x);
    };

    const onUp = () => {
      isDown = false;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove, { passive: true });
    window.addEventListener('mouseup', onUp);

    track.addEventListener('touchstart', onDown, { passive: true });
    track.addEventListener('touchmove', onMove, { passive: true });
    track.addEventListener('touchend', onUp, { passive: true });
  }

  function bindControls(moduleEl) {
    const track = moduleEl.querySelector('[data-upsell-track]');
    const prev = moduleEl.querySelector('[data-upsell-arrow="prev"]');
    const next = moduleEl.querySelector('[data-upsell-arrow="next"]');
    if (!track || !prev || !next) return;

    if (track.dataset.controlsBound !== '1') {
      track.dataset.controlsBound = '1';

      enableDragScroll(track);

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollAmount(track), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: getScrollAmount(track), behavior: 'smooth' });
      });

      const refresh = () => updateArrowState(track, prev, next);
      track.addEventListener('scroll', () => requestAnimationFrame(refresh), { passive: true });
      window.addEventListener('resize', () => requestAnimationFrame(refresh), { passive: true });
    }

    requestAnimationFrame(() => updateArrowState(track, prev, next));
  }

  function hideSlideForCard(cardEl) {
    const slide = cardEl.closest('[data-upsell-slide]');
    if (slide) slide.style.display = 'none';
  }

  function applyHiddenFromStorage(moduleEl) {
    const hidden = new Set(getHidden());
    if (!hidden.size) return;

    const cards = moduleEl.querySelectorAll('.upcart-upsell-item-card');
    cards.forEach(card => {
      const id = getIdForCard(card);
      if (id && hidden.has(id)) hideSlideForCard(card);
    });
  }

  function bindHideOnAdd(moduleEl) {
    if (moduleEl.dataset.hideOnAddBound === '1') return;
    moduleEl.dataset.hideOnAddBound = '1';

    moduleEl.addEventListener('click', (e) => {
      const btn = e.target.closest('input.upcart-upsells-button, button.upcart-upsells-button');
      if (!btn) return;

      const card = btn.closest('.upcart-upsell-item-card');
      if (!card) return;

      hideSlideForCard(card);

      const id = getIdForCard(card);
      if (id) {
        const arr = getHidden();
        if (!arr.includes(id)) {
          arr.push(id);
          setHidden(arr);
        }
      }
    }, { passive: true });
  }

  function setup() {
    const moduleEl = document.querySelector(MODULE_SEL);
    if (!moduleEl) return;

    injectStylesOnce();
    ensureArrows(moduleEl);

    const ok = reconcileSlider(moduleEl);
    if (!ok) return;

    bindControls(moduleEl);
    bindHideOnAdd(moduleEl);
    applyHiddenFromStorage(moduleEl);
  }

  function scheduleSetup() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      setup();
    });
  }

  function attachModuleObserver(moduleEl) {
    if (moduleObserver) return;

    moduleObserver = new MutationObserver(() => {
      scheduleSetup();
    });

    moduleObserver.observe(moduleEl, { childList: true, subtree: true });
  }

  const poll = setInterval(() => {
    const moduleEl = document.querySelector(MODULE_SEL);
    if (!moduleEl) return;

    attachModuleObserver(moduleEl);
    setup();
  }, 400);

  const initialModule = document.querySelector(MODULE_SEL);
  if (initialModule) attachModuleObserver(initialModule);
  setup();
})();